/**
 * Product Card — Mobile Swipe Carousel
 * Version: 3.2.0
 *
 * Neu: Carousel läuft auch auf Featured Collections (product-list)
 * zusätzlich zu Collection-Seiten (.collection__inner)
 */

(function () {
  'use strict';

  if (!('ontouchstart' in window)) return;
  if (window.__midgardProductCardTouchLoaded) return;

  window.__midgardProductCardTouchLoaded = true;

  let refreshRaf = null;

  function recalculateCarousel(card) {
    const track = card.querySelector('.pc-track');
    if (!track) return;
    const width = track.clientWidth;
    if (!width) return;
    const currentIndex = Math.round(track.scrollLeft / width);
    track.scrollLeft = currentIndex * width;
  }

  function initCarousel(card) {
    if (card.dataset.carouselReady === '1') return;

    const mediaLink = card.querySelector('.product-card__media');
    if (!mediaLink) return;

    const primary = mediaLink.querySelector('.product-card__image--primary');
    const secondary = mediaLink.querySelector('.product-card__image--secondary');
    if (!primary || !secondary) return;

    card.dataset.carouselReady = '1';

    const track = document.createElement('div');
    track.className = 'pc-track';
    track.setAttribute('aria-hidden', 'true');

    const slide0 = document.createElement('div');
    slide0.className = 'pc-slide';
    const img0 = primary.cloneNode(true);
    img0.className = 'pc-img';
    img0.alt = '';
    img0.setAttribute('aria-hidden', 'true');
    slide0.appendChild(img0);

    const slide1 = document.createElement('div');
    slide1.className = 'pc-slide';
    const img1 = secondary.cloneNode(true);
    img1.className = 'pc-img';
    img1.alt = '';
    img1.setAttribute('aria-hidden', 'true');
    slide1.appendChild(img1);

    track.appendChild(slide0);
    track.appendChild(slide1);
    mediaLink.appendChild(track);

    primary.classList.add('pc-original-hidden');
    secondary.classList.add('pc-original-hidden');

    const dots = document.createElement('div');
    dots.className = 'pc-dots';
    dots.setAttribute('aria-hidden', 'true');

    const dot0 = document.createElement('span');
    dot0.className = 'pc-dot pc-dot--active';

    const dot1 = document.createElement('span');
    dot1.className = 'pc-dot';

    dots.appendChild(dot0);
    dots.appendChild(dot1);
    mediaLink.appendChild(dots);

    let scrollRaf = null;

    track.addEventListener('scroll', () => {
      if (scrollRaf !== null) cancelAnimationFrame(scrollRaf);

      scrollRaf = requestAnimationFrame(() => {
        scrollRaf = null;

        const width = track.clientWidth;
        if (!width) return;

        const index = Math.round(track.scrollLeft / width);
        dot0.classList.toggle('pc-dot--active', index === 0);
        dot1.classList.toggle('pc-dot--active', index === 1);
      });
    }, { passive: true });

    let touchStartX = 0;
    let touchStartY = 0;
    let didSwipe = false;

    track.addEventListener('touchstart', (event) => {
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
      didSwipe = false;
    }, { passive: true });

    track.addEventListener('touchmove', (event) => {
      const deltaX = Math.abs(event.touches[0].clientX - touchStartX);
      const deltaY = Math.abs(event.touches[0].clientY - touchStartY);

      if (deltaX > 8 && deltaX > deltaY) {
        didSwipe = true;
      }
    }, { passive: true });

    track.addEventListener('click', (event) => {
      if (didSwipe) {
        event.preventDefault();
        event.stopPropagation();
        didSwipe = false;
        return;
      }

      if (mediaLink.href) {
        window.location.href = mediaLink.href;
      }
    }, { capture: true });
  }

  function getGrid() {
    return (
      document.querySelector('.collection__inner') ||
      document.querySelector('product-list')
    );
  }

  function refreshCarousels() {
    if (refreshRaf !== null) cancelAnimationFrame(refreshRaf);

    refreshRaf = requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        refreshRaf = null;

        const grid = getGrid();
        if (!grid) return;

        grid.querySelectorAll('product-card').forEach((card) => {
          if (card.dataset.carouselReady !== '1') {
            initCarousel(card);
          } else {
            recalculateCarousel(card);
          }
        });
      });
    });
  }

  function activateCarouselSystem(grid) {
    if (grid.dataset.touchCarouselActive === '1') return;

    grid.dataset.touchCarouselActive = '1';

    const observerRoot =
      grid.closest('.shopify-section') ||
      grid.closest('[id^="shopify-section-"]') ||
      grid.parentElement;

    if (!observerRoot) return;

    refreshCarousels();

    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (
          mutation.type === 'childList' &&
          (mutation.addedNodes.length || mutation.removedNodes.length)
        ) {
          refreshCarousels();
          break;
        }
      }
    }).observe(observerRoot, {
      childList: true,
      subtree: true
    });

    observerRoot.addEventListener('click', (event) => {
      if (event.target.closest('collection-layout-selector-button')) {
        refreshCarousels();
      }
    }, { passive: true });
  }

  function startCarouselSystem() {
    const grid = getGrid();
    if (!grid) return;

    if (!('IntersectionObserver' in window)) {
      activateCarouselSystem(grid);
      return;
    }

    const startObserver = new IntersectionObserver((entries) => {
      if (!entries.some(entry => entry.isIntersecting)) return;

      startObserver.disconnect();
      activateCarouselSystem(grid);
    }, {
      rootMargin: '600px 0px'
    });

    startObserver.observe(grid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startCarouselSystem,
      { once: true }
    );
  } else {
    startCarouselSystem();
  }

})();